import { render, staticRenderFns } from "./JitsiVideo.vue?vue&type=template&id=278fbd21&"
import script from "./JitsiVideo.vue?vue&type=script&lang=js&"
export * from "./JitsiVideo.vue?vue&type=script&lang=js&"
import style0 from "./JitsiVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports